import React, { useCallback } from 'react';

import BuoyCarouselCards from 'components/BuoyCarouselCards';
import ErrorBoundary from 'components/ErrorBoundary';
import ErrorMessage from 'components/ErrorMessage';
import type { NearbyStation } from 'types/buoys';

import styles from './BuoyCarousel.module.scss';

const errorBoundaryProperties = {
  location: 'BuoyCarousel',
};

interface Props {
  loading?: boolean;
  stations?: Array<NearbyStation>;
  error?: Error | string | boolean;
  trackLocation?: string;
}

const BuoyCarousel: React.FC<Props> = ({ loading, stations, error, trackLocation }) => {
  const renderErrorMessage = useCallback(
    () => (
      <ErrorMessage
        className={styles.errorMessage}
        dataTestId="buoy-carousel-error"
        message={error ? 'Oh buoy something went wrong' : 'Error loading nearby buoys'}
      />
    ),
    [error],
  );

  return (
    <section className={styles.buoyCarousel}>
      <ErrorBoundary
        error={error}
        errorBoundaryId="buoy-carousel"
        properties={errorBoundaryProperties}
        render={renderErrorMessage}
      >
        <BuoyCarouselCards loading={loading} stations={stations} trackLocation={trackLocation} />
      </ErrorBoundary>
    </section>
  );
};

export default BuoyCarousel;
